<template>
    <v-card :flat="flat" :tile="flat" :height="height" v-on="events" :elevation="elevation" :style="style">
        <video-background v-if="backgroundVideo"
                          class="fill-height fill-width"
                          :style="{height: videoHeight}"
                          :src="$api.getImageUrl(backgroundVideo) + '&_ignore=.mp4'"
        >
            <component-wrapper :config="component" />
        </video-background>
        <v-auto-img v-else-if="backgroundImage"
                    :src="backgroundImage"
                    :position="backgroundPosition"
                    :height="height"
                    :cover="this.cover"
                    :contain="!this.cover"
        >
            <component-wrapper :config="component" />
        </v-auto-img>
        <component-wrapper v-else :config="component" />
    </v-card>
</template>

<script>
import components from '../component.js'
import VideoBackground from 'vue-responsive-video-background-player'
export default {
    name: 'zoezi-card',

    zoezi: {
        title: 'Card',
        icon: 'mdi-card-bulleted-outline'
    },

    components: {
        VideoBackground,
    },

    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({})
        },
        backgroundImage: {
            title: 'Background image',
            type: String,
            fulltype: 'image'
        },

        backgroundPosition: {
            title: 'Background position',
            type: String,
            fulltype: 'backgroundposition',
            default: 'center center'
        },

        cover: {
            title: 'Cover card with background image',
            type: Boolean,
            default: true
        },
        backgroundVideo: {
            title: 'Background video',
            type: String,
            fulltype: 'video'
        },
        flat: {
            title: 'Flat and square card',
            type: Boolean,
            default: false
        },
        height: {
            title: 'Height',
            type: String,
            fulltype: 'csssize',
        },
        link: {
            title: 'Link',
            type: Object,
            fulltype: 'link',
            typeinfo: {
                clearable: true
            }
        },
        radius: {
            title: 'Corner radius',
            type: String,
            fulltype: 'csssize',
            global: true
        },
        elevation: {
            title: 'Elevation',
            type: Number,
            typeinfo: {
                min: 0,
                max: 24
            },
            global: true
        }
    },

    computed: {
        videoHeight() {
            // Safe way to provide default height in MB pages. Adding default to height prop would change existing cards.
            return this.height || '200px';
        },
        events() {
            if (!this.$root.edit && this.link) {
                return {
                    click: () => {
                        this.$root.followLink(this.link);
                    }
                }
            }

            return {};
        },
        style() {
            if (this.radius) {
                return {'border-radius': this.radius}
            }

            return undefined;
        }

    },
    migrations: [
        (props) => {
            if (typeof props.height !== 'string' && props.height) {
                props.height = props.height + 'px';
            }
        }
    ]
}
</script>
